/**
 * SHELL — practice intro. Practice mode is fully offline-capable and never
 * submits a score or affects the streak; it lets players learn the controls or
 * keep rolling after they've spent today's one attempt.
 */

import type { App } from '../../app';
import type { Screen } from '../router';
import { div, el } from '../dom';
import { brand, iconButton } from '../components';

export function practiceScreen(app: App): Screen {
  const screen = div('dr-screen');
  const card = div('dr-card');
  card.append(brand('Practice mode'));
  card.append(
    el('p', { class: 'dr-muted', text: "Roll today's course freely. Practice runs don't count toward your streak or the leaderboard — just for fun and warm-ups." }),
    el('p', { class: 'dr-faint', text: 'Drag anywhere to steer. Release to recenter.' }),
  );
  const cta = iconButton('dr-btn dr-btn--primary dr-btn--lg dr-btn--block', 'play', 'Start practice', () => void app.startRun({ practice: true }));
  cta.setAttribute('autofocus', '');
  card.append(cta);
  screen.append(card);
  screen.append(iconButton('dr-btn dr-btn--ghost dr-btn--block', 'back', 'Back', () => app.go('landing')));
  return { node: screen };
}
